import { useLocale } from '../../../../context/NbLocalizationContext';
import { NbButton } from '../../../../shared/components/button/Button';
import { ModalHeader } from '../../../../shared/components/modal/ModalHeader';
import classes from './CurrencyExchangeNotAvailableModal.module.scss';

export interface CurrencyExchangeNotAvailableModalProps {
  onCancel: () => void;
  icon: React.ReactNode;
  title: string;
  text?: string;
  children?: React.ReactNode;
  isModal?: boolean;
}

export const CurrencyExchangeNotAvailableModal = ({
  onCancel,
  icon,
  title,
  text,
  children,
  isModal = true,
}: CurrencyExchangeNotAvailableModalProps) => {
  const { translation } = useLocale();

  return (
    <div className={classes.info}>
      {isModal && (
        <ModalHeader
          title={translation.currencyChange.title}
          onClose={onCancel}
          className={classes.infoHeader}
          isSmall
          isWithDivider
        />
      )}

      <div className={classes.infoContent}>
        <span className={classes.infoIcon}>{icon}</span>
        <p className={classes.infoTitle}>{title}</p>
        <p className={classes.infoText}>{text}</p>
        <div>{children}</div>
        {isModal && (
          <NbButton
            onClick={onCancel}
            className={classes.infoButton}
          >
            {translation.general.ok}
          </NbButton>
        )}
      </div>
    </div>
  );
};
